// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3VXG60h","footerNavs":"_3T77pMR","footerBottom":"_VCVAFlW","footerBottomInner":"_m8gimlc"};